import LayoutSkeleton from "@/components/LayoutSkeleton";
import { useAuth } from "@/contexts/AuthContext";
import type { RoleGuardProps } from "@/types/auth";
import { Role } from "@shared/types/models";
import { Navigate } from "react-router-dom";

const RoleGuard = ({ children, adminOnly = false }: RoleGuardProps) => {
  const { user, isLoading } = useAuth();

  if (isLoading) return <LayoutSkeleton />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== Role.ADMIN) return <Navigate to="/dashboard" replace />;

  return <>{children}</>;
};

export { RoleGuard };
